import { render, staticRenderFns } from "./Priory.vue?vue&type=template&id=540ac2b3&"
import script from "./Priory.vue?vue&type=script&lang=js&"
export * from "./Priory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports